import { flatten } from 'flat'
import en from '../../../config/locales/en.yml'
import metrics from '../../../config/locales/metrics.yml'
import singlePageTest from '../../../config/locales/single_page_test.yml'

// Convert rails values syntax `%{value}` to react-intl syntax `{value}
const flatLocales = { ...flatten(en.en), ...flatten(metrics.en), ...flatten(singlePageTest.en) }
const locales = Object.keys(flatLocales).reduce((l, key) => {
  if (flatLocales[key]) {
    l[key] = flatLocales[key].replace(/%{/g, '{')
  } else {
    l[key] = ''
  }
  return l
}, {})

export default locales
